import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { keycloak, initConfig } from './services/keycloakServices';

import registerServiceWorker from './registerServiceWorker';
import cookies from 'browser-cookies';
import App from './components/App';
import WithThreeDotsContentLoader from './components/loadingComponent/WithDotsContentLoader';
import LoginStore from './stores/LoginStore';

import './styles/master_styleWelllynx.scss';
import './styles/_all-skins.scss';
import './index.scss';

import AppConfiguration from './assets/Configuration/ConfigurationFile.json';
import SessionCheckLoader from './components/loadingComponent/SessionCheckLoader';

//let jwt = localStorage.getItem('jwt');
let jwt = cookies.get('jwt');
if (jwt) {
  LoginStore.setUser();
  LoginStore.setJwt();
}

// const Login = React.lazy(() => import('./components/loginComponent/Login'))

document.title = AppConfiguration.docTitle;

ReactDOM.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      ...initConfig,
      enableLogging: true,
      // onLoad: 'login-required'
    }}
    LoadingComponent={<SessionCheckLoader />}
    onEvent={(event, error) => {
      // console.log('Keycloak event:', event);
      // if (error) {
      //         console.error('Keycloak detailed error:', {
      //                 error,
      //                 event,
      //                 authenticated: keycloak.authenticated,
      //                 didInitialize: keycloak.didInitialize
      //         });
      // }
    }}
    onTokens={(tokens) => {
      // console.log('Keycloak tokens:', tokens);
      // LoginAPI.login({username:"yassin",password:"YA2024"})
    }}
    isLoadingCheck={(keycloak) => {
      // console.log('Loading state:', keycloak.authenticated, keycloak.didInitialize);
      return !keycloak.didInitialize;
    }}
  >
    <Router>
      <Switch>
        <Route
          path="/wlmgUsers"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}>
            //                 <div>Authorized</div>
            //         </WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgGroups"
          render={() => (
            //      LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgProducers"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgFields"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgAllWells"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgGeneric"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgEsp"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgSrp"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgSkid"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgHorizPump"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgTags"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgStateTags"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgML"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //     <Login/>
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgHome"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />

        <Route
          path="/wlmgLogin"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <Redirect to="/wlmgHome" />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlmgLutz"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
        <Route
          path="/wlHealth"
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <App />
          )}
          // ) : (
          //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
          // )
        />
        <Route
          render={() => (
            // LoginStore.isLoggedIn() ? (
            <Redirect to="/wlmgHome" />
            // ) : (
            //         <WithThreeDotsContentLoader isLoginPage={true}><div>Authorized</div></WithThreeDotsContentLoader>
            // )
          )}
        />
      </Switch>
    </Router>
  </ReactKeycloakProvider>,
  document.getElementById('root')
);
registerServiceWorker();

window.keycloak = keycloak;
